import http from "../../../api/http";
import { serialize } from "../../../api/jsonApiParser";

export const saveDefaultVariables = payload => {
  return http.put("DefaultVariable", serialize(payload, "DefaultVariable"));
};
